/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

const Pallet = (props) => {
  const { nodes, materials } = useGLTF("/new_models/pallet.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.pallet_3.geometry}
        material={materials.pallet_3}
      />
    </group>
  );
}

useGLTF.preload("/new_models/pallet.glb");

export default Pallet;
